// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgba%28112, 113, 115, 0.4%29%27 stroke-width=%271.5%27 preserveAspectRatio=%27none%27 %3E%3Cline x1=%2724%27 y1=%270%27 x2=%270%27 y2=%2724%27%3E%3C/line%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rp-container {
  display: flex;
  flex-direction: column;
}

.rp-card {
  width: -webkit-fill-available;
  margin-top: 1rem;
  padding: 1rem;
  border: 2px solid rgb(247, 241, 240);
  border-radius: 3px;
}

.rp-title-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* margin: 1rem 0; */
}

.rp-card-option-container {
  display: flex;
  flex-direction: column;
  margin: 1rem 0 0 0;
  padding: 1rem;
  /* border: 1px solid #dcdcdc; */
  gap: 1rem;
  background: #f7f1f099;
  border-radius: 3px;
}

.rp-card-option {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.rp-card-option-values-container {
  display: flex;
  flex-direction: row;
  row-gap: 0.5rem;
  flex-wrap: wrap;
  gap: 0.8rem;
}

.rp-card-option-values-container-yn {
  flex-wrap: nowrap !important;
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  row-gap: 0.5rem;
}

.rp-option-item {
  display: flex;
  box-sizing: border-box;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  padding: 0.8rem 1.2rem;
  /* margin: 0 0.5rem 0 0; */
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.rp-option-name {
  font-weight: 600;
}

.rp-price {
  font-weight: 600;
  color: #6f1920;
  white-space: nowrap !important;
}

.rp-price.oos {
  font-weight: 600;
  color: #707173;
  white-space: nowrap !important;
}

.rp-option-item:hover {
  border: 1px solid #6f1920;
}

/* .rp-option-item:has(> label > input:disabled) {
   background-blend-mode: luminosity;
} */

.rp-option-item:has(> label > input:disabled) {
  position: relative; /* Make sure the parent element is relatively positioned */
}

.rp-option-item:has(> label > input:disabled)::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: no-repeat center/100% 100% rgb(255, 255, 255);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  color: #707173e6;
  opacity: 0.5; /* Adjust the opacity as needed */
  z-index: 1; /* Ensure the slash is above the image */
  pointer-events: none; /* Allow interactions with the underlying element */
}

.rp-option-item:has(> label > input:checked) {
  border: 2px solid #6f1920;
  background-blend-mode: normal;
}

.rp-option-item > label > input {
  margin-right: -1rem;
  opacity: 0;
  z-index: -1;
  cursor: pointer;
}

.rp-option-item > label {
  padding: 1rem;
  margin: -1rem;
  cursor: pointer;
  width: -webkit-fill-available;
}

.rp-quantity-container {
  margin: 1rem 0 1rem 0;
}

.rp-quantity-buttons-container {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}

.rp-quantity-buttons-container > div {
  display: flex;
  height: auto;
  width: 3rem;
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  text-align: center;
  justify-items: center;
  justify-self: center;
}

.rp-quantity-buttons-container > div > span {
  margin: auto;
}

.rp-add-button {
  margin: 1rem 0 0 0;
}

.rp-add-button > button {
  width: 100%;
  height: 3rem;
  font-size: 0.8rem;
  border: 1.5px solid;
  min-height: 48px;
}

.rp-quantity-button-input {
  border: 1.5px solid #dbdcdc;
  border-radius: 3px;
  height: 48px;
  width: 48px;
  min-width: 48px;
  color: #707173;
  font-size: inherit;
  box-sizing: border-box;
  background-color: #fff;
  padding: 0px !important;
}

.rp-card-option-value-input-container {
  width: 100%;
}

.rp-image-swatches {
  font-size: 0;
  /* width: 130px;
  height: 80px; */
  width: 98px;
  height: 70px;
  border: 3px solid #fff;
  background-color: #ffffff;
  -webkit-box-shadow: 0 0 2px #454f5b;
  background-size: cover;
  background-position: center;
}

.rp-option-colour-swatches:has(> label > input:checked) {
  border: 1px solid #6f1920;
}
`, "",{"version":3,"sources":["webpack://./src/modules/product/components/Addon/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,kBAAkB,EAAE,0DAA0D;AAChF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAAyD;EACzD,yDAAiV;EACjV,gBAAgB;EAChB,YAAY,EAAE,iCAAiC;EAC/C,UAAU,EAAE,wCAAwC;EACpD,oBAAoB,EAAE,mDAAmD;AAC3E;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ;iBACe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".rp-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.rp-card {\n  width: -webkit-fill-available;\n  margin-top: 1rem;\n  padding: 1rem;\n  border: 2px solid rgb(247, 241, 240);\n  border-radius: 3px;\n}\n\n.rp-title-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  /* margin: 1rem 0; */\n}\n\n.rp-card-option-container {\n  display: flex;\n  flex-direction: column;\n  margin: 1rem 0 0 0;\n  padding: 1rem;\n  /* border: 1px solid #dcdcdc; */\n  gap: 1rem;\n  background: #f7f1f099;\n  border-radius: 3px;\n}\n\n.rp-card-option {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.rp-card-option-values-container {\n  display: flex;\n  flex-direction: row;\n  row-gap: 0.5rem;\n  flex-wrap: wrap;\n  gap: 0.8rem;\n}\n\n.rp-card-option-values-container-yn {\n  flex-wrap: nowrap !important;\n  display: flex;\n  flex-direction: row;\n  gap: 0.8rem;\n  row-gap: 0.5rem;\n}\n\n.rp-option-item {\n  display: flex;\n  box-sizing: border-box;\n  border: 1px solid #dcdcdc;\n  border-radius: 4px;\n  padding: 0.8rem 1.2rem;\n  /* margin: 0 0.5rem 0 0; */\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n}\n\n.rp-option-name {\n  font-weight: 600;\n}\n\n.rp-price {\n  font-weight: 600;\n  color: #6f1920;\n  white-space: nowrap !important;\n}\n\n.rp-price.oos {\n  font-weight: 600;\n  color: #707173;\n  white-space: nowrap !important;\n}\n\n.rp-option-item:hover {\n  border: 1px solid #6f1920;\n}\n\n/* .rp-option-item:has(> label > input:disabled) {\n   background-blend-mode: luminosity;\n} */\n\n.rp-option-item:has(> label > input:disabled) {\n  position: relative; /* Make sure the parent element is relatively positioned */\n}\n\n.rp-option-item:has(> label > input:disabled)::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: no-repeat center/100% 100% rgb(255, 255, 255);\n  background-image: url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgba%28112, 113, 115, 0.4%29%27 stroke-width=%271.5%27 preserveAspectRatio=%27none%27 %3E%3Cline x1=%2724%27 y1=%270%27 x2=%270%27 y2=%2724%27%3E%3C/line%3E%3C/svg%3E');\n  color: #707173e6;\n  opacity: 0.5; /* Adjust the opacity as needed */\n  z-index: 1; /* Ensure the slash is above the image */\n  pointer-events: none; /* Allow interactions with the underlying element */\n}\n\n.rp-option-item:has(> label > input:checked) {\n  border: 2px solid #6f1920;\n  background-blend-mode: normal;\n}\n\n.rp-option-item > label > input {\n  margin-right: -1rem;\n  opacity: 0;\n  z-index: -1;\n  cursor: pointer;\n}\n\n.rp-option-item > label {\n  padding: 1rem;\n  margin: -1rem;\n  cursor: pointer;\n  width: -webkit-fill-available;\n}\n\n.rp-quantity-container {\n  margin: 1rem 0 1rem 0;\n}\n\n.rp-quantity-buttons-container {\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n}\n\n.rp-quantity-buttons-container > div {\n  display: flex;\n  height: auto;\n  width: 3rem;\n  border: 1px solid #dcdcdc;\n  box-sizing: border-box;\n  text-align: center;\n  justify-items: center;\n  justify-self: center;\n}\n\n.rp-quantity-buttons-container > div > span {\n  margin: auto;\n}\n\n.rp-add-button {\n  margin: 1rem 0 0 0;\n}\n\n.rp-add-button > button {\n  width: 100%;\n  height: 3rem;\n  font-size: 0.8rem;\n  border: 1.5px solid;\n  min-height: 48px;\n}\n\n.rp-quantity-button-input {\n  border: 1.5px solid #dbdcdc;\n  border-radius: 3px;\n  height: 48px;\n  width: 48px;\n  min-width: 48px;\n  color: #707173;\n  font-size: inherit;\n  box-sizing: border-box;\n  background-color: #fff;\n  padding: 0px !important;\n}\n\n.rp-card-option-value-input-container {\n  width: 100%;\n}\n\n.rp-image-swatches {\n  font-size: 0;\n  /* width: 130px;\n  height: 80px; */\n  width: 98px;\n  height: 70px;\n  border: 3px solid #fff;\n  background-color: #ffffff;\n  -webkit-box-shadow: 0 0 2px #454f5b;\n  background-size: cover;\n  background-position: center;\n}\n\n.rp-option-colour-swatches:has(> label > input:checked) {\n  border: 1px solid #6f1920;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
